<template>
  <div v-if="condition">
    <template v-if="!isEdit">
      <v-layout>
        <v-flex class="form-control pr-2">{{condition.caseText}}</v-flex>
        <v-btn fab depressed color="primary" small @click="isEdit = true">
          <v-icon>edit</v-icon>
        </v-btn>
        <v-btn fab depressed color="primary" small @click="$emit('onDelete')">
          <v-icon>delete</v-icon>
        </v-btn>
      </v-layout>
    </template>
    <div v-else :key="id">
      <template v-for="(c, index) in cases">
        <case-condition-manage
          :key="`${id}_case_${c.caseA}_${c.symbol}_${c.caseB}_${index}`"
          v-model="cases[index]"
          @onDelete="onDelete(index)"
        ></case-condition-manage>
        <v-divider class="mb-2" :key="'case_divider_'+index"></v-divider>
      </template>
      <div class="add-conversation text-xs-center" style="cursor: pointer" @click="addCase">
        <i class="fa fa-plus middle"></i>
        {{ $t('Add Case') }}
      </div>
      <div class="text-xs-center">
        <div v-if="errors.has('caseB')" class="pa-2">
          <span class="red--text">{{ errors.first('caseB') }}</span>
        </div>
        <v-btn outline color="grey" @click="onCancel">{{$t('cancel')}}</v-btn>
        <v-btn depressed color="primary" @click="onSave">{{$t('Save')}}</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import CaseConditionManage from './CaseConditionManage'
import moment from 'moment'
export default {
  props: ['value'],
  data() {
    return {
      condition: null,
      cases: null,
      isEdit: false,
      id: ''
    }
  },
  components: {
    CaseConditionManage
  },
  mounted() {
    this.id = moment().format('x')
    this.condition = this.value
    this.cached_ccondition = JSON.stringify(this.value)
    this.reset()
  },
  methods: {
    reset() {
      var cases =
        this.condition.case != '' && this.condition.case != null
          ? this.condition.case.split('&&')
          : []
      var conditions = []

      if (cases.length > 0) {
        cases.map(el => {
          if (el.includes('>=')) {
            var expression = el.split('>=')
            var expression1 = expression[0]
            var expression2 = expression[1]

            conditions.push({
              caseA: expression1,
              caseB: expression2,
              symbol: '>='
            })
          } else if (el.includes('<=')) {
            var expression = el.split('<=')
            var expression1 = expression[0]
            var expression2 = expression[1]

            conditions.push({
              caseA: expression1,
              caseB: expression2,
              symbol: '<='
            })
          } else if (el.includes('==')) {
            var expression = el.split('==')
            var expression1 = expression[0]
            var expression2 = expression[1]

            conditions.push({
              caseA: expression1,
              caseB: expression2,
              symbol: '=='
            })
          } else if (el.includes('!=')) {
            var expression = el.split('!=')
            var expression1 = expression[0]
            var expression2 = expression[1]

            conditions.push({
              caseA: expression1,
              caseB: expression2,
              symbol: '!='
            })
          } else if (el.includes('<')) {
            var expression = el.split('<')
            var expression1 = expression[0]
            var expression2 = expression[1]

            conditions.push({
              caseA: expression1,
              caseB: expression2,
              symbol: '<'
            })
          } else if (el.includes('>')) {
            var expression = el.split('>')
            var expression1 = expression[0]
            var expression2 = expression[1]

            conditions.push({
              caseA: expression1,
              caseB: expression2,
              symbol: '>'
            })
          } else if (el == 'others') {
          } else {
          }
        })
      } else {
        this.isEdit = true
      }
      this.cases = conditions
    },
    onDelete(index) {
      this.cases.splice(index, 1)
    },
    addCase() {
      this.cases.push({
        caseA: null,
        caseB: null,
        symbol: '=='
      })
    },
    onCancel() {
      this.isEdit = false
      if (this.cases.length == 0) {
        this.$emit('onDelete')
      }
      this.id = moment().format('x')
      this.condition = JSON.parse(this.cached_ccondition)
      this.reset()
    },
    onSave() {
      var vm = this
      vm.$validator.validateAll().then(result => {
        if (!result) {
          vm.goToErrorInput()
          // do stuff if not valid.
          // console.log(this.$validator.errors.items)
          return false
        }
        var result = []
        var newCase = []
        vm.cases.map(el => {
          if (el.caseA != null && el.caseA != '' && el.caseB != null && el.caseB != '') {
            result.push(el.caseA + el.symbol + el.caseB)
            newCase.push(el)
          }
        })
        vm.cases = newCase
        var data = vm.condition
        data.case = result.join('&&')
        data.caseText = vm.convertCondition(result.join('&&'))
        vm.$emit('input', data)
        vm.condition = data
        vm.isEdit = false
        if (data.case == '') {
          vm.$emit('onDelete')
        }
        vm.id = moment().format('x')
        vm.cached_ccondition = JSON.stringify(vm.condition)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/flow/SubConditionManage.vue